import Vue from 'vue';
import * as lodash from 'lodash/fp';
import { defineModule, localActionContext } from "direct-vuex"

import * as InternalUser from "@/lib/Util/Types/InternalUser/InternalUser";
import * as REST from '@/lib/Util/REST'
import { RootState } from '@/store/Shared'

const state = {
    value: [] as InternalUser.T[],
    message: REST.getEmpty(),
}

const mutations = {
    updateValue(state: State, model: InternalUser.T[] | null) {
        const values = model ?? []
        state.value = values;
    },
    updateListWithItem(state: State, model: InternalUser.T | null) {
        if (model) {
            const index = state.value.findIndex(x => x.id === model.id)
            if (index >= 0) {
                Vue.set(state.value, index, model)
            }
            else {
                state.value.push(model)
            }
        }
    },
    updateMsg(state: State, v: REST.RestMessage) {
        state.message = v
    },
    toggleActivation(state: State, x: string) {
        const found = state.value.find(v => v.id === x)
        if (found) {
            found.active = !found.active
        }
    }
}

const getters = {
}

const actions = {
    async LOAD(context: any) {
        /* eslint-disable @typescript-eslint/no-use-before-define */
        const { commit, state } = actionCtx(context)
        const rootState = context.rootState as RootState
        try {
            const loading_msg = {
                ...state.message,
                loading: true
            }
            commit.updateMsg(loading_msg)
            commit.updateValue([])
            const req = {
                token: rootState.authentication?.token ?? "NO TOKEN",
                url: "/compragauser",
                payload: {},
                transformer: InternalUser.tryParseList
            };
            const result = await REST.GET(state.message, req);
            const msg = {
                ...lodash.cloneDeep(result.msg),
                text: "Successfully loaded user list",
                timeout: 5000
            }
            commit.updateValue(result.value)
            commit.updateMsg(msg)
        }
        catch (ex) {
            const msg = {
                ...lodash.cloneDeep(state.message),
                text: JSON.stringify(ex)
            }
            commit.updateMsg(msg)
        }
    },
}

export const internal = {
    namespaced: true as const,
    state,
    mutations,
    getters,
    actions
}

export type Mutations = typeof mutations
export type State = typeof state
export type Getters = typeof getters
export type Actions = typeof actions

export const module = defineModule(internal)
export type Module = typeof module
export default module

const actionCtx = (context: any) => localActionContext(context, module)
